module.exports = {"create_invoice_simulation":"Crear simulació de factura","date_range":"Rang de dates","username":"Nom usuari","device_model":"Model dispositiu","select_model":"Tria Model","device":"Dispositiu","select_device":"Tria Dispositiu","create":"Crear","invoice_simulation":"Simulacions de factura"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/InvoiceSimulation.json
// module id = 590
// module chunks = 1